import { Stack } from "@mui/material"
import './Background.css'
import sea from '../assets/svgGame/sea.svg'
import upper_sea from '../assets/svgGame/upper_sea.svg'
import blue_corals from '../assets/svgGame/blue_corals.svg'
import sky from '../assets/svgGame/sky.svg'
import cloud_1 from '../assets/svgGame/cloud_1.svg'
import cloud_2 from '../assets/svgGame/cloud_2.svg'
import diver from '../assets/svgGame/diver.svg'
import basket from '../assets/svgGame/basket.svg'
import headerBg from '../assets/svgGame/header_bg.svg'
import bottle from '../assets/svgGame/bottle.svg'
import glove from '../assets/svgGame/glove.svg'
import shoe from '../assets/svgGame/shoe.svg'
import tin from '../assets/svgGame/tin.svg'
import canned from '../assets/svgGame/canned.svg'
import glass from '../assets/svgGame/glass.svg'
import mustard from '../assets/svgGame/mustard.svg'

const Backgrounds = ({ basketRef, setItemRef }) => {
    // const { collectingItems, setBasketRef, setItemRef } = useCollection();

    // useEffect(() => {
    //     setBasketRef(basketRef.current);
    // }, [setBasketRef]);

    return (
        <Stack
            position='absolute'
            top={0}
            left={0}
            width='100vw'
            height='100vh'
            zIndex={-1}
        >
            <img
                src={sky}
                style={{ width: "100%", position: 'absolute', objectFit: 'fill' }}
            />

            <img
                src={cloud_1}
                className="cloud1"
                style={{
                    position: 'absolute',
                    top: 90,
                    left: -50
                }}
            />

            <img
                src={cloud_2}
                className="cloud2"
                style={{
                    position: 'absolute',
                    top: 90,
                    left: -50
                }}
            />

            <img
                src={sea}
                style={{ width: "100%", position: 'absolute', bottom: 0 }}
            />

            <img
                src={blue_corals}
                style={{ width: "100%", position: 'absolute', bottom: 10 }}
            />

            <img
                src={upper_sea}
                style={{ position: 'absolute', bottom: 310, right: 15 }}
            />

            {/* Garbege images start */}
            <img
                ref={(el) => setItemRef('mustard', el)}
                src={mustard}
                className="garbage-item"
                style={{ position: 'absolute', bottom: 230, left: '80%', cursor: 'pointer' }}
            />

            <img
                ref={(el) => setItemRef('bottle', el)}
                src={bottle}
                className="garbage-item"
                style={{ position: 'absolute', bottom: 70, left: '50%', cursor: 'pointer' }}
            />

            <img
                ref={(el) => setItemRef('glove', el)}
                src={glove}
                className="garbage-item"
                style={{ position: 'absolute', bottom: 215, left: '45%', cursor: 'pointer' }}
            />

            <img
                ref={(el) => setItemRef('shoe', el)}
                src={shoe}
                className="garbage-item"
                style={{ position: 'absolute', bottom: 50, left: '5%', cursor: 'pointer' }}
            />

            <img
                ref={(el) => setItemRef('tin', el)}
                src={tin}
                className="garbage-item"
                style={{ position: 'absolute', bottom: 150, left: '75%', cursor: 'pointer' }}
            />

            <img
                ref={(el) => setItemRef('glass', el)}
                src={glass}
                className="garbage-item"
                style={{ position: 'absolute', bottom: 250, left: '27%', cursor: 'pointer' }}
            />

            <img
                ref={(el) => setItemRef('canned', el)}
                src={canned}
                className="garbage-item"
                style={{ position: 'absolute', bottom: 40, left: '85%', cursor: 'pointer' }}
            />
            {/* Garbege images end */}

            <img
                ref={basketRef}
                src={basket}
                style={{ position: 'absolute', bottom: 115, left: 50 }}
            />

            <img
                src={diver}
                style={{ position: 'absolute', bottom: 180, left: -200 }}
            />

            <img
                src={headerBg}
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: "100%",
                    objectFit: 'cover'
                }}
            />
        </Stack>
    )
}
export default Backgrounds